import script from "./raffleMove.vue?vue&type=script&lang=ts&setup=true"
export * from "./raffleMove.vue?vue&type=script&lang=ts&setup=true"

import "./raffleMove.vue?vue&type=style&index=0&id=23bc75ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bc75ec"]])

export default __exports__